import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type AccentName = 'sky' | 'violet' | 'emerald' | 'rose' | 'amber'

export const ACCENTS: Record<AccentName, string> = {
  sky: '#38bdf8',
  violet: '#a78bfa',
  emerald: '#34d399',
  rose: '#fb7185',
  amber: '#fbbf24',
}

type SettingsState = {
  service: string
  accent: AccentName
  pageSize: number
  setService: (s: string) => void
  setAccent: (a: AccentName) => void
  setPageSize: (n: number) => void
}

export const useSettings = create<SettingsState>()(
  persist(
    (set) => ({
      service: 'https://bsky.social',
      accent: 'sky',
      pageSize: 50,
      setService: (service) => set({ service }),
      setAccent: (accent) => set({ accent }),
      setPageSize: (pageSize) => set({ pageSize }),
    }),
    { name: 'bskydisc.settings' },
  ),
)

export function applyAccent(name: AccentName) {
  const hex = ACCENTS[name]
  const root = document.documentElement
  root.style.setProperty('--accent', hex)
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  root.style.setProperty('--accent-soft', `rgba(${r}, ${g}, ${b}, 0.18)`)
  root.style.setProperty('--accent-strong', `rgba(${r}, ${g}, ${b}, 0.85)`)
}
